import React, { useContext, useState, useEffect } from "react";
import { db, serverTime } from "../Utils/firebase";

import { CgClose } from "react-icons/cg";

import { AuthContext } from "../context/AuthContext";
import { LinkContext } from "../context/LinkContext";

function MyLink() {
  const { al } = useContext(LinkContext);
  const [alert, setAlert] = useState(false);
  const { userData, userAuth, setUserData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [btnText, setBtntext] = useState("Remove All");
  const [mount, setMount] = useState(true);
  const [params, setParams] = useState(null);
  const [error, setError] = useState(null);
  const [mylink, setMylink] = useState([]);

  const removeAll = () => {
    setLoading(true);
    setBtntext("Removing ...");
    closeAlert();
    db.collection("user")
      .doc(userAuth.uid)
      .update({
        account: [],
        updateAt: serverTime,
      })
      .then(() => {
        db.collection("user")
          .doc(userAuth.uid)
          .get()
          .then((doc) => {
            setUserData(doc.data());
            if (mount) {
              setLoading(false);
              setBtntext("Remove All");
              setParams(null);
            }
          })
          .catch((error) => {
            if (mount) {
              setError(error.code);
              setLoading(false);
              setBtntext("Remove All");
              setParams(null);
            }
          });
      })
      .catch((error) => {
        if (mount) {
          setError(error.code);
          setLoading(false);
          setBtntext("Remove All");
          setParams(null);
        }
      });
  };

  const removeItem = () => {
    if (params) {
      setLoading(true);
      closeAlert();
      setBtntext("Removing ...");
      db.collection("user")
        .doc(userAuth.uid)
        .get()
        .then((doc) => {
          const currentAccount = doc.data().account;
          const newAccount = currentAccount.filter((l) => params !== l.id);
          db.collection("user")
            .doc(userAuth.uid)
            .update({
              account: newAccount,
              updateAt: serverTime,
            })
            .then(() => {
              db.collection("user")
                .doc(userAuth.uid)
                .get()
                .then((doc) => {
                  setUserData(doc.data());
                  setMylink(doc.data().account);
                  setLoading(false);
                  setBtntext("Remove All");
                  setParams(null);
                })
                .catch((error) => {
                  if (mount) {
                    setError(error.code);
                    setLoading(false);
                    setBtntext("Remove All");
                    setParams(null);
                  }
                });
            })
            .catch((error) => {
              if (mount) {
                setError(error.code);
                setLoading(false);
                setBtntext("Remove All");
                setParams(null);
              }
            });
        })
        .catch((error) => {
          if (mount) {
            setError(error.code);
            setLoading(false);
            setBtntext("Remove All");
            setParams(null);
          }
        });
    }
  };

  const openAlert = (id) => {
    setAlert(true);
    setParams(id);
    document.body.style.overflow = "hidden";
  };
  const closeAlert = () => {
    setAlert(false);
    document.body.style.removeProperty("overflow");
  };

  const buttonChoose = () => {
    if (params !== "") {
      if (params === "removeAll") {
        return <button onClick={removeAll}>Yes</button>;
      } else {
        return <button onClick={removeItem}>Yes</button>;
      }
    }
  };

  const renderUrl = (url, subdomain, anchor) => {
    const spliturl = url.replace("https://", "");
    if (subdomain === true) {
      return `https://${anchor}.${spliturl}`;
    } else {
      return url + anchor;
    }
  };

  useEffect(() => {
    if (userData.account.length >= 1) {
      setMylink(userData.account);
    } else {
      setMylink([]);
    }
  }, [userData]);

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <>
      <div className="all-link divContent darktextColor darkdivColor">
        {alert && (
          <div className="alert">
            <div className="alert-box">
              <h5>Delete this Account?</h5>
              <p>This action cannot be undone!</p>
              <div className="option-wrap">
                {buttonChoose()}
                <button onClick={closeAlert}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        <div className="head-tab">
          <h5 className="textTitle textMedium">My Account</h5>
          <p className="text textMedium">{mylink.length} / 5</p>
        </div>
        <div className="box-links">
          {mylink.length ? (
            mylink.map((l) => {
              const current_site = al.filter((li) => li.site === l.site);
              return (
                <div className="link" key={l.id}>
                  <div className="head-link">
                    <h5 className="textTitle">{l.site}</h5>
                    {!loading ? (
                      <>
                        <CgClose
                          size="1.2em"
                          title="Delete this link"
                          className="icon-delete"
                          onClick={() => openAlert(l.id)}
                        />
                      </>
                    ) : (
                      <>
                        {params === l.id ? (
                          <span className="textSmall">removing ...</span>
                        ) : null}
                      </>
                    )}
                  </div>
                  <div className="url-link">
                    <input
                      type="text"
                      className="input-1 disable-text"
                      name="url"
                      onClick={(e) => e.target.blur()}
                      onChange={(e) => e.preventDefault()}
                      onInput={(e) => e.preventDefault()}
                      onKeyDown={(e) => e.preventDefault()}
                      onSelect={(e) => e.preventDefault()}
                      defaultValue={renderUrl(
                        current_site[0].url,
                        current_site[0].sub,
                        l.anchor
                      )}
                      disabled={true}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text">There is no Accounts</p>
          )}
        </div>
        {mylink.length > 1 ? (
          <button
            className={
              loading
                ? "btn-in darktextColor textTitle disable"
                : "btn-in darktextColor textTitle "
            }
            onClick={() => openAlert("removeAll")}
            disabled={loading}
          >
            {btnText}
          </button>
        ) : null}

        {error ? (
          <div className="error">
            <p className="text">{error}</p>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default MyLink;
